// Game constants
export const GAME_CONSTANTS = {
  QUEST_DURATION: 24 * 60 * 60, // 24 hours in seconds
  HELICOPTER_GAME: {
    WIDTH: 400,
    HEIGHT: 600,
    GRAVITY: 0.25,
    LIFT: -5,
    OBSTACLE_WIDTH: 60,
    OBSTACLE_GAP: 200,
    OBSTACLE_SPEED: 2
  }
};

// Colors
export const COLORS = {
  PRIMARY: '#007bff',
  PRIMARY_HOVER: '#0056b3',
  SUCCESS: '#28a745',
  SUCCESS_HOVER: '#218838',
  DANGER: '#dc3545',
  DANGER_HOVER: '#c82333',
  SECONDARY: '#6c757d',
  SECONDARY_HOVER: '#545b62',
  LIGHT_BLUE: '#f0f7ff',
  BLUE: '#2563eb',
  GRAY: '#666',
  WHITE: '#fff',
  BLACK: '#000'
};

// Quest data
export const QUEST_DATA = {
  EATING_OUT: {
    id: 'eating-out',
    title: 'Don\'t eat out for 24 hours',
    description: 'Save your cash by eating from home, don\'t purchase food from a restaurant for 24 hours',
    reward: 5
  },
  SAVINGS: {
    id: 'savings',
    title: 'Move $5 from checking to savings',
    description: 'Build your savings habit by transferring $5 from your checking account to your savings account',
    reward: 3
  }
}; 